const baseData = {
  twitter: "https://twitter.com/exoeffect",
  defaultTitle: "Exo Imaging",
  defaultDescription: "",
  defaultKeywords: "",
  defaultPreviewImage: {
    width: 1200,
    height: 630,
    src: ""
  },
  defaultLocation: "https://www.exo.inc"
}

const metaData = {
  ...baseData,
  mailing: {
    street: "4201 Burton Drive",
    // line02: "Suite 102",
    line03: "",
    city: "Santa Clara",
    state: "CA",
    postal: "95054",
    country: ""
  },
  socialNetwork: {
    linkedin: "https://www.linkedin.com/company/exo-imaging.com/about/",
    twitter: baseData.twitter,
    facebook: "https://www.facebook.com/exoeffect",
    instagram: "https://www.instagram.com/exoeffect/",
    spotify: "https://open.spotify.com/show/2vGxOyz1NSkuOyw5lW4iPi"
  }
}

export default metaData
